import { render, staticRenderFns } from "./Protocol.vue?vue&type=template&id=6142bed4&scoped=true"
import script from "./Protocol.vue?vue&type=script&lang=ts&setup=true"
export * from "./Protocol.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Protocol.vue?vue&type=style&index=0&id=6142bed4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6142bed4",
  null
  
)

export default component.exports